




























































import { Component, Prop, Watch,Vue } from 'vue-property-decorator'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
@Component({
    components: {
        swiper,
        swiperSlide
    }
})
export default class ImageSwipers extends Vue {
    @Prop()
    public imgList:any
    @Prop()
    public indexs:any
    @Prop()
    public cnt:any
    public swiperOption0:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt0',
          prevEl: '.swiper-button-ppp0'
        },        
    }
     public swiperOption1:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt1',
          prevEl: '.swiper-button-ppp1'
        },        
    }
    public swiperOption2:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt2',
          prevEl: '.swiper-button-ppp2'
        },        
    }
    public swiperOption3:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt3',
          prevEl: '.swiper-button-ppp3'
        },        
    }
    public swiperOption4:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt4',
          prevEl: '.swiper-button-ppp4'
        },        
    }

    public mounted(){
    //     this.swiperOption = {
    //     observeParents: true,
    //     observer: true,
    //     freeMode: true,
    //     slidesPerView: 'auto',
    //     centeredSlides:false,
    //     spaceBetween: 10,
    //     loop:false,
    //     navigation: {
    //       nextEl: '.swiper-button-ntt1',
    //       prevEl: '.swiper-button-ppp1'
    //     },
    //     pagination:this.indexs
    //   }    
    }
    // get swiperIndex(){
    //     let swiper:any = (this.$refs.sinoSwiper as any).swiper;
    //     console.log('swiper-->',swiper);
    //     return ''
    // }
}
